import { type FC } from "react";
import { Chip, type ChipProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AutomationStatusType } from "@/types/graphql/partner.generated";
import {
  AUTOMATION_STATUS_FALLBACK_KEY,
  AUTOMATION_STATUS_KEYS,
  labelKeyFor,
} from "../model/automationLabels";

const STATUS_COLORS: Record<AutomationStatusType, ChipProps["color"]> = {
  [AutomationStatusType.DraftType]: "default",
  [AutomationStatusType.ActiveType]: "success",
  [AutomationStatusType.PausedType]: "warning",
  [AutomationStatusType.ArchivedType]: "default",
};

/**
 * Статус автоматизации цветом темы; архив контурный, как у рассылок. Статус
 * вне карты (рост enum на бэкенде раньше релиза кабинета) не остаётся без
 * подписи: цвет default, текст из AUTOMATION_STATUS_FALLBACK_KEY.
 */
export const AutomationStatusChip: FC<{ status: AutomationStatusType }> = ({
  status,
}) => {
  const { t } = useTranslation();
  return (
    <Chip
      size="small"
      color={STATUS_COLORS[status] ?? "default"}
      variant={
        status === AutomationStatusType.ArchivedType ? "outlined" : "filled"
      }
      label={t(
        labelKeyFor(
          AUTOMATION_STATUS_KEYS,
          status,
          AUTOMATION_STATUS_FALLBACK_KEY
        )
      )}
    />
  );
};
